import { useCallback } from 'react';
import { ECountry, ELanguage } from '@portals/help-center-core';
import { useParams } from 'next/navigation';
import { useRouter } from '@/i18n/navigation';
import { getCategoriesRoute, TRouteCommon } from '@/_constants/routes';
import { LANGUAGE_OPTIONS } from '@/_components/client-root-layout/_components/app-header/_constants';

export type TParams = { newLocale?: ELanguage; newCountry?: ECountry };

export const useUpdatePath = () => {
  const router = useRouter();
  const { country } = useParams<TRouteCommon>();

  const updatePath = useCallback(
    ({ newLocale, newCountry }: TParams) => {
      const countryToUse = newCountry || country || ECountry.RUSSIA;
      const defaultCountryPath = getCategoriesRoute({
        country: countryToUse,
      });

      let localeToUse = newLocale;
      if (newCountry) {
        const language = LANGUAGE_OPTIONS[newCountry];
        localeToUse = (language[0].value as ELanguage) || newLocale;
      }

      router.push({ pathname: defaultCountryPath }, { locale: localeToUse });
    },
    [country, router],
  );

  return { updatePath };
};
